import React from 'react'
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);

interface LeadQualityDoughnutChartProps {
    totalLeads: number,
    leadgetCall: number,
    backgrounds: any,
    labels: any,
}


const LeadQualityDoughnutChart: React.FC<LeadQualityDoughnutChartProps> = ({ totalLeads, leadgetCall, backgrounds, labels }) => {
    const data = {
        labels: labels,
        datasets: [
            {
                data: [totalLeads, leadgetCall],
                backgroundColor: backgrounds,
                hoverBackgroundColor: backgrounds,
                borderWidth: 0,
            },
        ],
    };

    const options = {
        cutout: '40%',
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem:any) => {
                        // Show only the amount without the label
                        return `${tooltipItem.raw.toLocaleString('en-IN')}`;
                    },
                },
                enabled: true,
            },
        },
    };

    return (
        <div style={{ width: '92px', height: '92px' }}>
            <Doughnut data={data} options={options} />
        </div>
    );
};

export default LeadQualityDoughnutChart